export default "__VITE_ASSET__CdAzRwUA__"